import React from "react";
import DrawingCanvas from "./components/DrawingCanvas";
import logo from "./assets/images/logo-full.svg";
import scribbles from "./assets/images/scribbles-peek-side.svg";
import otto from "./assets/images/otto-peek-side.svg";

function App() {
  return (
    <div className="min-h-screen py-4 overflow-hidden bg-gradient-radial from-indigo-500 via-indigo-500 to-indigo-700">
      <div className="max-w-4xl mx-auto">
        <header className="text-center mb-4">
          <div className="max-w-3xl mx-auto rounded-xl bg-indigo-600 p-2">
            <h1 className="text-xl font-bold text-white mb-2">
              ✏️ Sketchy Creatures Challenge! ✏️
            </h1>
            <h2 className="text-sm text-indigo-100">
              You'll have 30 seconds to draw the prompt that appears below.
              Press start when you're ready!
            </h2>
          </div>
        </header>
        <main>
          <div className="relative">
            <img
              src={scribbles}
              alt="Scribbles Peeking"
              className="absolute top-10 -left-28 h-56 mx-auto z-0"
            />
            <img
              src={otto}
              alt="Otto Peeking"
              className="absolute top-32 -right-36 h-80 mx-auto z-0"
            />
            <div className="relative z-10">
              <DrawingCanvas />
            </div>
          </div>
        </main>
        <footer className="text-center mt-4">
          <p className="text-indigo-300">
            Made with 💜 by
            <a href="https://scribenote.com">
              {" "}
              <img
                src={logo}
                alt="Scribenote Logo"
                className="h-6 ml-2 inline"
              />
            </a>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;
